import { render } from "./BaseButton.vue?vue&type=template&id=20688d6a&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=20688d6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20688d6a"

export default script